import { connect } from "react-redux";
import { useState, useEffect } from "react";
import {camelCase, merge} from "lodash";

import ReactFileReader from "react-file-reader";
import NotificationManager from "react-notifications/lib/NotificationManager";

import { Actions as ACCOUNTINGACTIONS } from "../../../store/actions/accountingActions";
import { Actions as ACCOUNTING_INTEGRATION_ACTIONS } from "../../../components/integrations/accountingIntegrations/store/accountingIntegrationActions";


import { CheckCircleIcon, DocumentArrowUpIcon, PlusCircleIcon, ExclamationCircleIcon } from "@heroicons/react/20/solid";
import CostCentersByLevel from "./CostCentersByLevel";

const CostCenters = ({
	setData,
	data,
	handleFiles,
	clearFiles,
	centersList,
	processingFile,
	dirty,
	save,
	connected,
	logo,
	integration,
	integrationName,
	importAccountingCategoriesAndCostCenters
}) => {
	const [dataLoaded, setDataLoaded] = useState(false);

	const addCenter = () => {
		const newData = [...data];
		newData.push({});
		setData(newData);
	};

	const submit = () => {
		let seen = [];

		//Prevent empty submit
		if (!data.length) {
			NotificationManager.error("There are no Cost Centers to submit!", "Cost Centers");
			return;
		}

		//Checks for duplicate and empty codes in form
		for (const code in data) {
			const num = data[code].code;

			if (!num) {
				NotificationManager.error("Code fields cannot be empty!", "Cost Centers");
				return;
			}

			if (seen.includes(num)) {
				NotificationManager.error(`Duplicate codes found: ${num}`, "Cost Centers");
				return;
			}

			seen.push(num);
		}

		NotificationManager.success("Submitted successfully", "Cost Centers");
		save(data);
		clearFiles();
	};

	useEffect(() => {
		if (centersList.length == 0 || processingFile) return;

		const newData = [...data];

		for (const center in centersList) {
			let replaced = false;
			for (const i in newData) {
				if (newData[i].code == centersList[center].code) {
					newData.splice(i, 1, centersList[center]);
					replaced = true;
				}
			}

			if (replaced) continue;
			newData.push(centersList[center]);
		}

		setData(newData);
	}, [processingFile]);

	useEffect(() => {
		if (dataLoaded) return;
		setDataLoaded(true);
	}, [data]);

	return (
		<>
			<form className="form-grid col-12">
				<div className="form-section col-span-3 row-span 2">
					<div className="col-xs-7 pull-left form-container">
						<h4>Cost Centers</h4>
					</div>
					{!connected && (
						<div className="col-xs-2 pull-right">
							<ReactFileReader
								fileTypes={[".csv", ".dbf", ".*", "application/dbase", "application/dbf"]}
								handleFiles={handleFiles}
							>
								{data.length == 0 ? (
									<div
										className="btn btn-success pull-right"
										type="button"
									>
										<DocumentArrowUpIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<div style={{ float: "left" }}>Import</div>
									</div>
								) : (
									<div
										className="btn btn-default pull-right"
										type="button"
									>
										<DocumentArrowUpIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<div style={{ float: "left" }}>Import</div>
									</div>
								)}
							</ReactFileReader>
						</div>
					)}
					{connected && (
						<div className="col-xs-4 pull-right text-right">
							Connected with
							<img src={logo} style={{ height: "2em", verticalAlign: "text-bottom" }} />
						</div>
					)}
					<div className="col-xs-12 form-container form-material">
						<table className="table table-borderless">
							<thead style={{ background: "#ea611c", color: "#fff" }}>
								<tr>
									<th scope="col">Level</th>
									<th scope="col">Code</th>
									<th scope="">Name</th>
								</tr>
							</thead>
							<tbody style={{ background: "#fff" }}>
								{data?.map((center, index) => {
									const updateField = (field, value) => {
										if (!field) return;
										const objectAtIndex = data[index];
										const newData = merge(objectAtIndex, {
											...(typeof field == "object" ? field : { [field]: value }),
										});
										const newArray = [...data];
										newArray[index] = newData;
										setData(newArray);
									};
									return (
										<CostCenterRow
											data={center}
											updateField={updateField}
											connected={connected}
										/>
									);
								})}
							</tbody>
						</table>
					</div>

					{
						connected ?
						<div className="col-xs-12 pull-right mb-10">
							<p>
								You are connected to {integrationName}. If you need to make changes to your ledgers, please do so in {integrationName}.
							</p>
							<button
								type="button"
								className="btn btn-success pull-right"
								onClick={() => importAccountingCategoriesAndCostCenters(integration)}
							>
								{/*<RefreshIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />*/}
								<span style={{ float: "left" }}>Import & Sync Accounting Categories from {integrationName}</span>
							</button>
						</div> : (
						<div>
							<div
								className="col-xs-12 pull-right"
								style={{ marginBottom: 10 }}
							>
								<button
									type="button"
									className="btn btn-success pull-right"
									onClick={() => addCenter()}
								>
									<PlusCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									<span style={{ float: "left" }}>Add</span>
								</button>
							</div>
							<div
								className="col-xs-12 pull-right"
								style={{ marginBottom: 10 }}
							>
								<button
									type="button"
									className="btn btn-success pull-right"
									onClick={() => submit()}
								>
									{
										dirty ?
											<ExclamationCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
											:
											<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									}
									<span style={{ float: "left" }}>
										{
											dirty ?
												"Save Changes"
												:
												"Saved"
										}
									</span>
								</button>
							</div>
						</div>
						)
					}


					<CostCentersByLevel />
				</div>
			</form>
		</>
	);
};

const CostCenterRow = ({ data, updateField, connected }) => {
	return (
		<tr>
			<td className="form-material form-container col-xs-3">
				{
					connected ?
						data?.level
						:
						<input
							id="level"
							name="level"
							className="form-control form-input"
							autoComplete="off"
							value={data?.level}
							onChange={(e) => {
								updateField("level", e.target.value || null);
							}}
						/>
				}
			</td>
			<td className="form-material form-container col-xs-3">
				{
					connected ?
						data?.code
						:
						<input
							id="code"
							name="code"
							className="form-control form-input"
							autoComplete="off"
							value={data?.code}
							onChange={(e) => {
								updateField("code", e.target.value || null);
							}}
						/>
				}
			</td>
			<td className="form-material form-container col-xs-3">
				{
					connected ?
						data?.name
						:
						<input
							id="name"
							name="name"
							className="form-control form-input"
							autoComplete="off"
							value={data?.name}
							onChange={(e) => {
								updateField("name", e.target.value || null);
							}}
						/>
				}
			</td>
		</tr>
	);
};

const mapStateToProps = (state) => {

	// object with accounting integrations (names as keys)
	const accountingIntegrations = state?.integration?.accounting
	const accountingIntegrationConnected = accountingIntegrations && Object.keys(accountingIntegrations).find(key => accountingIntegrations[key]?.connected)

	return {
		processingFile: state?.accounting?.fileImport?.processingFile,
		centersList: state?.accounting?.fileImport?.data || [],
		data: state?.accounting?.costCenters?.data || [],
		// dirty state is to show that the data has been changed and needs to be saved
		dirty: state?.accounting?.costCenters?.dirty ?? false,
		connected: accountingIntegrationConnected?.length > 0,
		integration: accountingIntegrationConnected,
		integrationName: accountingIntegrationConnected ? state?.integrationDetails?.accounting?.[camelCase(accountingIntegrationConnected)]?.name : null,
		logo: accountingIntegrationConnected ?  state?.integrationDetails?.accounting?.[camelCase(accountingIntegrationConnected)]?.logo : null
	};
};

const mapDispatchToProps = (dispatch) => ({
	importAccountingCategoriesAndCostCenters: (integration) => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.importAccountingCategoriesAndCostCenters(integration)),
	handleFiles: (files) => dispatch(ACCOUNTINGACTIONS.handleAccountingFiles(files)),
	clearFiles: () => dispatch(ACCOUNTINGACTIONS.accountingClearFile()),
	save: (data) => dispatch(ACCOUNTINGACTIONS.accountingSaveCostCenters(data)),
	setData: (data) => dispatch(ACCOUNTINGACTIONS.updateCostCenters(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CostCenters);
